import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/error.tsx");
